import { useState } from 'react'
import { useGame } from '../state/store'
import { OPERATORS, isOperatorUnlocked, type OperatorDef } from '../engine/operators'

export function OperatorBar() {
  const edition = useGame((s) => s.edition)
  const distinct = useGame((s) => s.distinct())
  const [selectedOp, setSelectedOp] = useState<OperatorDef | null>(null)

  return (
    <div className="rounded-lg border border-ink-border bg-ink-panel p-4">
      <div className="mb-3 text-xs font-bold uppercase tracking-widest text-ink-teal">
        Operators
      </div>
      <div className="flex flex-wrap gap-2">
        {OPERATORS.map((op) => {
          const unlocked = isOperatorUnlocked(op, edition, distinct)
          const isSelected = selectedOp?.symbol === op.symbol
          return (
            <button
              key={op.symbol}
              disabled={!unlocked}
              onClick={() => setSelectedOp(isSelected ? null : op)}
              className={`flex flex-col items-center rounded border px-3 py-2 text-sm transition ${
                unlocked
                  ? isSelected
                    ? 'border-ink-teal bg-ink-teal/10 text-ink-teal shadow-glow'
                    : 'border-ink-tealdim text-ink-text hover:shadow-glow'
                  : 'border-ink-border text-ink-muted opacity-40'
              }`}
            >
              <span className="text-lg font-bold">{op.symbol}</span>
              <span className="text-[9px] uppercase">{op.name}</span>
              {!unlocked && (
                <span className="text-[8px] text-ink-muted">
                  E{op.edition} · {op.distinctLetters} letters
                </span>
              )}
            </button>
          )
        })}
      </div>
      {selectedOp && (
        <div className="mt-3 rounded border border-ink-border bg-ink-bg p-2 text-xs text-ink-muted">
          <span className="font-bold text-ink-text">{selectedOp.symbol}</span>{' '}
          {getOpDescription(selectedOp.symbol)}
        </div>
      )}
    </div>
  )
}

function getOpDescription(symbol: string): string {
  switch (symbol) {
    case '+': return 'Merge two letters into one slot. Output = A + B.'
    case '-': return 'Sacrifice one letter. Target gains 1.8× its output. Frees a slot.'
    case '×': return 'Multiply two letters (within 3 levels). Output capped.'
    case '÷': return 'Split one letter into two at 55% each. Net +10% output.'
    case '^': return 'Exponentiate one letter. Output = min(A^1.15, A×6).'
    case '=': return 'Fire a burst: (A×B×…) × 8 Ink. 30s cooldown per letter.'
    default: return ''
  }
}
